import classNames from 'classnames';
import AddToCartLink from './AddToCartLink';
import { useProductPageContext } from './hooks/useProductPageContext';
import ProductPrice from './sections/main/right/product/ProductPrice';

const BottomBar = () => {
  const { selectedOffer, selectedWarranty, isFetchingSku } =
    useProductPageContext();

  return (
    <div className="fixed bottom-0 z-[70] w-full bg-white shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.1),0_-2px_4px_-2px_rgba(0,0,0,0.1)] lg:hidden">
      <div
        className={classNames(
          'xl:reebelo-container mx-auto px-5 py-5 xl:px-8',
          {
            'opacity-60': isFetchingSku,
          },
        )}
      >
        <div className="flex items-center justify-between gap-2">
          <ProductPrice />
          <div className="shrink-0 xs:min-w-[200px]">
            <AddToCartLink
              testingId="e2e-pdp-bottom-bar-add-to-cart"
              className="w-full"
              id="bottomBarPurchaseCont"
              offer={selectedOffer}
              selectedWarranty={selectedWarranty}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default BottomBar;
